import { CommonModule } from '@angular/common';
//import { Component, AfterViewInit, Inject, PLATFORM_ID, OnDestroy } from '@angular/core';
import { Component, AfterViewInit, Inject, PLATFORM_ID, OnDestroy, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
//import $ from 'jquery';

import { ActivatedRoute, RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { Subject } from 'rxjs';
@Component({
  selector: 'app-associate-time-log',
  standalone: true,
  imports: [CommonModule, TranslateModule, HttpClientModule, FormsModule, RouterLink],
  providers: [Base64UrlService],
  templateUrl: './associate-time-log.component.html',
  styleUrl: './associate-time-log.component.scss'
})
export class AssociateTimeLogComponent  implements AfterViewInit{
  @Input() inputId?: string;
  @Input() inputUserId?: string;
  @Input() embeddedMode?: boolean;
  @Input() fromMode?: 'resource' | 'approver';
  @HostBinding('class.embedded-mode') get isEmbeddedMode() { return !!this.embeddedMode; }
  @Output() backClicked = new EventEmitter<void>();

  userName: any;
  lang: any;
  userCode: any;
  timeSheetTopPannel: any;
  monthDropdown: any;
  timeSheetData: any;
  timeSheetCmnData: any;
  jobOrderData: any;
  noteTypes: any;
  expensesTypes: any;
  timesheetId: any;
  timesheetIdOrg: any;
  userId: any;
  userIdOrg: any;
  editingRow: number | null = null;
  dashboard_msg: any;
  selectAll = false;
  selectedTimesheetId: number | string = '';
  userRole: any;
  Url: any;
  expandedRows: boolean[] = [];
  expandedRowsButton: boolean[] = [];

  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  constructor(private route: ActivatedRoute, private auth: AuthService,private translate: TranslateService, private pageTitle: PageTitleService, private ts: TimesheetService, private en: EncryptionService, private http: HttpClient, private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { 
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') { 

      this.lang = (localStorage.getItem('site_lang')?localStorage.getItem('site_lang'): 'en');
      console.log(this.lang)
      translate.use(this.lang);
    }
  }

  ngOnInit() {
    console.log('🚀 associate-time-log component initialized');
    console.time('⏱️ Total ngOnInit');
    
    this.userName = this.auth.getName();
    this.pageTitle.setTitle('menu.timesheet');
    if (isPlatformBrowser(this.platformId)) {
/*
      this.timesheetId = this.en.decryptionAES(Base64UrlService.decode(this.route.snapshot.params['id']));
      this.timesheetIdOrg = this.route.snapshot.params['id'];
      if (this.route.snapshot.params['userId']) {
        
        this.userId = this.en.decryptionAES(Base64UrlService.decode(this.route.snapshot.params['userId']));
        this.userIdOrg = this.route.snapshot.params['userId'];
      }
*/
      const rawId = this.inputId ?? this.route.snapshot.params['id'];
      const rawUserId = this.inputUserId ?? this.route.snapshot.params['userId'];

      this.timesheetId = this.en.decryptionAES(Base64UrlService.decode(rawId));
      this.timesheetIdOrg = rawId;

      if (rawUserId) {
        this.userId = this.en.decryptionAES(Base64UrlService.decode(rawUserId));
        this.userIdOrg = rawUserId;
      }

      // console.log(this.userId);
      this.userRole = this.auth.getRole();
      // const fromParam = this.route.snapshot.queryParams['from'];
      const fromParam = this.fromMode ?? this.route.snapshot.queryParams['from'];
      if (fromParam === 'resource') {
        //this.Url = 'representative-resource-timesheet/' + this.timesheetIdOrg + '/' + this.userIdOrg;
        this.Url = '/representative-resource-timesheet/' + this.timesheetIdOrg + '/' + this.userIdOrg;
      } else if (fromParam === 'approver') {
        //this.Url = 'representative-approver-timesheet/' + this.timesheetIdOrg + '/' + this.userIdOrg;
        this.Url = '/representative-approver-timesheet/' + this.timesheetIdOrg + '/' + this.userIdOrg;
      } else if (this.userRole == 'Client' || this.userRole == 'Admin' || this.userRole == 'Rep') {
        //this.Url = 'client-timesheet/';
        this.Url = '/client-timesheet/';
        if (this.route.snapshot.params['userId']) {
          this.Url = this.Url + this.timesheetIdOrg + '/' + this.userIdOrg;
        } else {
          this.Url = this.Url + this.timesheetIdOrg;
        }
      } else if (this.userRole == 'Staff') {
        //this.Url = 'timesheet/';
        this.Url = '/timesheet/';
        if (this.route.snapshot.params['userId']) {
          this.Url = this.Url + this.timesheetIdOrg + '/' + this.userIdOrg;
        } else {
          this.Url = this.Url + this.timesheetIdOrg;
        }
      }  
      this.dashboard_msg = null;
      this.dashboard_msg = localStorage.getItem('dashboard_msg');
    
      localStorage.removeItem('dashboard_msg');
    
      this.userName = this.auth.getName();
      this.pageTitle.setTitle('menu.timesheetlog');
      this.selectedTimesheetId = this.timesheetId;
      this.getMonthDropDown();
      this.getTimesheetLogData();
    }
    
    console.timeEnd('⏱️ Total ngOnInit');
    // this.getLog();
  }
  getMonthDropDown() {
    // this.ts.getMonthList()
    // this.ts.getMonthWithTimesheetId()
    this.ts.getMonthWithTimesheetIdNew(this.userId)
    .subscribe({
      next: (resMonthList: any) => {
        this.monthDropdown = resMonthList.data;
        // console.log(this.monthDropdown);        
      },
      error: (err: any) => {
        console.log(err.message);
        if (err.status == 401) {
          this.auth.logout();
		  return
        }
      }
    });
  }
  
  getTimeDiffInMinutes(start: string, end: string) {    
      const startTime = new Date(start).getTime();
      const endTime = new Date(end).getTime();
      const diffMs = endTime - startTime;
      const diffMin = Math.floor(diffMs / (1000 * 60));    // convert to minutes
      let rt = this.addMinutesWithOverflow(start, diffMin).split('T')[1].split(':');
      let finalEndTime = `${parseInt(rt[0], 10)}:${rt[1]}`;
      return finalEndTime;
    }
    
    addMinutesWithOverflow(dateStr: string, minutes: number): string {
      const base = new Date(dateStr);
    
      // Add minutes normally
      const updated = new Date(base.getTime() + minutes * 60000);
    
      // Calculate total minutes since start of the day
      const diffMs = updated.getTime() - new Date(base.toDateString()).getTime();
      const totalMinutes = diffMs / 60000;
    
      const hours = Math.floor(totalMinutes / 60);
      const mins = Math.floor(totalMinutes % 60);
    
      // Format back as overflow time
      const hh = hours.toString().padStart(2, '0');
      const mm = mins.toString().padStart(2, '0');
    
      const datePart = dateStr.split("T")[0];
    
      return `${datePart}T${hh}:${mm}:00`;
    }
  getTimesheetLogData() {
    console.time('⏱️ Total getTimesheetLogData');
    console.time('⏱️ API Call: getTimeSheetLogById');
    
    this.ts.getTimeSheetLogById(this.timesheetId)
      .subscribe({
        next: (res: any) => {
          console.timeEnd('⏱️ API Call: getTimeSheetLogById');
          
          if (res.status) {
            console.log('📊 Raw data count:', res.data.lineItems?.length || 0);
            console.time('⏱️ Map and Calculate');
            
            // console.log(res.data);
            // this.timeSheetData = res.data;

            // this.timesheetId = -2145145950;
            this.timeSheetCmnData = res.data.timeSheet;
            this.timeSheetData = res.data.lineItems.map((item: any) => {
            // パフォーマンス最適化: 関数呼び出しを事前計算
            const dayWeekData = this.getDayWeekKey(item.dayDate);
            const statusData = this.getStatus(item.status, 's');
            const noteData = this.getNote(item.noteId);
            const expensesData = this.getExpenses(item.expenseId);
            const statusClass = this.getClass(item.status);
            
            // ログデータの事前計算
            const processedLogs = item.timesheetLineItemLogs?.map((log: any) => ({
              ...log,
              statusKey: this.getStatus(log.currentStateID, 's').statusKey,
              formattedDate: this.dateFormat(log.createDate)
            })) || [];
            
            return {
              ...item,
              // Convert start/finish/breaks into HH:mm for direct binding
              startTime: (item.startTime == '1972-01-12T00:00:00') ? '' : String(this.toTimeString(item.startTime)).padStart(2, '0'),
              startTimeOrg: item.startTime,
              endTime: (item.endTime == '1972-01-12T00:00:00') ? '' : String(this.getTimeDiffInMinutes(item.startTime, item.endTime)).padStart(2, '0'),
              endTimeOrg: item.endTime,
              markedForSubmit: false,
              // 事前計算された表示値
              dayWeekDay: dayWeekData.day,
              dayWeekKey: dayWeekData.weekdayKey,
              dayWeekShort: dayWeekData.shortweekday,
              statusKey: statusData.statusKey,
              statusClass: statusClass,
              noteKey: noteData.noteKey,
              expensesKey: expensesData.expensesKey,
              processedLogs: processedLogs
            };
            });
            
            console.timeEnd('⏱️ Map and Calculate');
            console.log('📊 Processed data count:', this.timeSheetData?.length || 0);
            console.log('✅ Data ready, Angular will now render...');
            
            this.timeSheetTopPannel = res.data.timesheetSummary[0];
            this.jobOrderData = res.data.jobOrder;
                        
            console.time('⏱️ getNoteTypes API');
            this.ts.getNoteTypes()
              .subscribe({
                next: (resNote: any) => {
                  console.timeEnd('⏱️ getNoteTypes API');
                  
                  if (resNote.status) {
                    // console.log(resNote.data);
                    this.noteTypes = resNote.data;
                  }
                },
                error: (err: any) => {
                  console.timeEnd('⏱️ getNoteTypes API');
                  if (err.status == 401) {
                    this.auth.logout();
					          return
                  }
                }
              });
            
            console.time('⏱️ getExpensesTypes API');
            this.ts.getExpensesTypes()
              .subscribe({
                next: (resExpenses: any) => {
                  console.timeEnd('⏱️ getExpensesTypes API');
                  console.timeEnd('⏱️ Total getTimesheetLogData');
                  console.log('🎉 All data loaded!');
                  
                  if (resExpenses.status) {
                    // console.log(resExpenses.data);
                    this.expensesTypes = resExpenses.data;
                  }
                },
                error: (err: any) => {
                  console.timeEnd('⏱️ getExpensesTypes API');
                  console.timeEnd('⏱️ Total getTimesheetLogData');
                  if (err.status == 401) {
                    this.auth.logout();
					          return
                  }
                }
              });            
          }
        },
        error: (err: any) => {
          if (err.status == 401) {
            this.auth.logout();
			      return
          }
        }
    })
  }

  getMonth(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { month: 'short' });
  }
  /* Edited by Honda
  getYear(dateStr: string): string {
    const [day, month, year] = dateStr.split('-').map(Number);
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', { year: 'numeric' });
  }
  */
  getYear(dateStr: string): string {
    const year = dateStr.split('-')[2];
    return this.lang === 'jp' ? `${year}年` : year;
  } 

  getDayWeekKey(dateString: string): { day: string, weekdayKey: string, shortweekday: string } {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const weekdayIndex = date.getDay();

    const weekdayKeys = [
      'WEEKDAYS.SUNDAY',
      'WEEKDAYS.MONDAY',
      'WEEKDAYS.TUESDAY',
      'WEEKDAYS.WEDNESDAY',
      'WEEKDAYS.THURSDAY',
      'WEEKDAYS.FRIDAY',
      'WEEKDAYS.SATURDAY'
    ];

    const weekdayKeysShort = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

    return { day, weekdayKey: weekdayKeys[weekdayIndex], shortweekday: weekdayKeysShort[weekdayIndex] };
  }

  getStatus(status: number, length: string): { statusKey: string } {
    let statusIndex = 0;
    if (status == 40) {
      statusIndex = 4;
    } else if (status == 30) {
      statusIndex = 3;
    } else if (status == 20) {
      statusIndex = 1;
    } else {
      statusIndex = 0;
    }

    let statusKeys: string[] = [];
    if (length == 's') {
      statusKeys = [
        "SHORTSTATUS.NOTSUBMIT",
        "SHORTSTATUS.SUBMIT",
        "SHORTSTATUS.FIX",
        "SHORTSTATUS.REJECT",
        "SHORTSTATUS.APPROVE"
      ];      
    } else if (length == 'l') {
      statusKeys = [
        "LONGSTATUS.NOTSUBMIT",
        "LONGSTATUS.SUBMIT",
        "LONGSTATUS.FIX",
        "LONGSTATUS.REJECT",
        "LONGSTATUS.APPROVE"
      ];
    }
    return {statusKey: statusKeys[statusIndex]}
  }

  getStartTime(dateString: string): string {
    const date = new Date(dateString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

 
  toTimeString(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    const hours = date.getHours().toString();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  fncCng(event: any) {
    const target = event.target as HTMLSelectElement;
    this.timesheetId = target.value;
    this.timesheetIdOrg = Base64UrlService.encode(this.en.encryptionAES(this.timesheetId.toString()));
    this.getTimesheetLogData();
    this.Url = '';
    // console.log(this.userRole);
    // console.log(this.timesheetIdOrg+" - "+this.userIdOrg);
    if (this.userRole == 'Client' || this.userRole == 'Admin' || this.userRole == 'Rep') {
      this.Url = 'client-timesheet/';
    } else if (this.userRole == 'Staff') {
      this.Url = 'timesheet/';
    }
    // console.log("hi -"+this.Url);
    if (this.route.snapshot.params['userId']) {
      // this.Url = this.Url + this.timesheetIdOrg + '/' + this.userIdOrg;
      this.Url += `${this.timesheetIdOrg}/${this.userIdOrg}`;
    } else {
      // this.Url = this.Url + this.timesheetIdOrg;
      this.Url += this.timesheetIdOrg;
    } 
    // console.log("hello - "+this.Url);
    // this.Url = this.Url + this.timesheetIdOrg;
    // const url =
    //   this.userRole === 'Client'
    //     ? 'client-timesheet/'
    //     : 'timesheet/';

    // const finalUrl = this.route.snapshot.params['userId']
    //   ? `${url}${this.timesheetIdOrg}/${this.userIdOrg}`
    //   : `${url}${this.timesheetIdOrg}`;
  }

  dateFormat(dateString: string): string {
    const date = new Date(dateString);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${year}/${month}/${day} ${hours}:${minutes}`;
  }

  
  getEndTime(dateString: string): string {
    const date = new Date(dateString);
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return `${hours}:${minutes}`;
  }

  getNote(note: number): { noteKey: string } {
    let statusIndex = 0;
    if (note == 10) {
      statusIndex = 0;
    } else if (note == 20) {
      statusIndex = 1;
    } else if (note == 40) {
      statusIndex = 2;
    } else if (note == 50) {
      statusIndex = 3;
    } else {
      statusIndex = 4;
    }
    const noteKeys = [
      "",
      "NOTEDD.PaidLeave",
      "NOTEDD.Tardiness",
      "NOTEDD.Absence",
      "NOTEDD.SeeComment"
    ];
    return {noteKey: noteKeys[statusIndex]}
  }
  
  getExpenses(expenses: number): { expensesKey: string } {
    let statusIndex = 0;
    if (expenses == 0) {
      statusIndex = 0;
    } else if (expenses == 1) {
      statusIndex = 1;
    } else if (expenses == 2) {
      statusIndex = 2;
    }
    const expensesKeys = [
      "",
      "ExpenseDD.AdvancePayment",
      "ExpenseDD.Transportation"
    ];
    return {expensesKey: expensesKeys[statusIndex]}
  }

  getClass(status: number): string {
    if(status < 20){
      return 'tr_non_submit';
    } else if(status == 20){
      return 'tr_submit';
    } else if(status == 30){
      return 'tr_reject';
    } else {
      return 'tr_approve';
    }
    
  }

  // getStatus() {

  // }

  toggleBelowRows(index: number) {
    this.expandedRows[index] = !this.expandedRows[index];
    this.expandedRowsButton[index] = !this.expandedRowsButton[index];
  }

  // パフォーマンス最適化: trackBy関数
  trackByTimesheetLineItemId(index: number, item: any): any {
    return item.timesheetLineItemId || index;
  }

  trackByLogId(index: number, log: any): any {
    return log.timesheetLineModifyId || index;
  }

  ngAfterViewInit(): void {
    // 
  }

  ngOnDestroy(): void {
    // 
  }

  onBack(): void {
    if (this.embeddedMode) {
      this.backClicked.emit();
    }
  }
}
